import { CREATE_USER_ITEMS } from "./config/create-user";

export function isCreateUserSaveButtonDisabled(userData) {
  const keys = ["name", "email", "mobile"];
  for (const key of keys) {
    if (!userData[key]?.trim()) {
      return true;
    }
  }
  return false;
}

export function doesErrorExistInCreateUserPayload(userData) {
  const returnObj = { error: false };
  for (const item of CREATE_USER_ITEMS) {
    if (
      item.apiKey &&
      item.regex &&
      userData[item.apiKey] &&
      !item.regex.test(userData[item.apiKey].trim())
    ) {
      returnObj.error = true;
      returnObj[item.apiKey] = item.validationError;
    }
  }
  return returnObj;
}

export function sanitizeUserDataPayload(userData) {
  const payload = {};
  for (const key in payload) {
    payload[key] = payload[key].trim();
  }
  for (const item of CREATE_USER_ITEMS) {
    if (item.apiKey) {
      payload[item.apiKey] = userData[item.apiKey]?.trim();
    }
  }
  return payload;
}
